export default "__VITE_ASSET__2wfhFf0I__"